import { VNode, Control, GxmlNode, IDesignerHost, CommonServiceIds } from '@genexus/designer-common';
import { h } from '@stencil/core';

export function getBreadcrumb(el: HTMLElement): Control[] {
    const breadcrumb: Control[] = [];
    let cont = true;
    let parent = getParent(el);

    do {
        if (parent) {
            if ((parent as Control).site)
                breadcrumb.push(parent as Control);

            parent = getParent(parent);
        }
        else
            cont = false;

    } while (cont)

    return breadcrumb;
}

export function getParent(node: Node) {
    let parent = node.parentNode;
    if (!parent && (node as any as ShadowRoot).host)
        parent = (node as any as ShadowRoot).host;

    return parent;
}

export function getGxmlNode(control: Control): GxmlNode {
    let site = control?.site;
    if (site) {
        let host = site.getService(CommonServiceIds.DesignerHost) as IDesignerHost;
        return host.document.getNodeById(site.id);
    }
}

export function isControlDraggable(control: Control): boolean {
    return true;
}

export function isControlDragActiveTarget(control: Element): boolean {
    return false;
}

export function renderVNodeToStencil(node: VNode) {
    if (!node)
        return <div></div>

    const TagName = node.tag;

    return (
        <TagName {...(node.attributes || {})} >
            {
                node.text ? node.text : (node.children || []).map(n => renderVNodeToStencil(n))
            }
        </TagName>
    );
}
